import { ProductVariation } from "../models/product-variation";

var ProductVariations = Backbone.Collection.extend({
    'model': ProductVariation
});

export {ProductVariations};